import ThaiBathInput from './ThaiBathInput'

export default ThaiBathInput
